import type { InstrumentRunPublic } from './types';

const ACTIVE_RUN_STATUSES: ReadonlyArray<InstrumentRunPublic['status']> = ['submitted', 'started'];
// Checked alongside status, not instead of it: decode can still be 'analyzing' after the
// instrument reports 'completed', and status alone would stop polling too early.
const ACTIVE_DECODE_STATUSES: ReadonlyArray<InstrumentRunPublic['decode_status']> = ['pending', 'analyzing'];

// True while the run should keep polling and the header should show in-progress UI.
export function isInstrumentRunActive(run: Pick<InstrumentRunPublic, 'status' | 'decode_status'>): boolean {
  return ACTIVE_RUN_STATUSES.includes(run.status) || ACTIVE_DECODE_STATUSES.includes(run.decode_status);
}

const pad = (n: number) => String(n).padStart(2, '0');

// Formats a duration in ms as `H:MM:SS`, or `MM:SS` under an hour.
export function formatElapsedDuration(durationMs: number): string {
  const totalSeconds = Math.max(0, Math.floor(durationMs / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${pad(minutes)}:${pad(seconds)}`;
}
